import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireCsAdmin = ({ children }) => {
  const { isAuthenticated, isCsAdmin, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/auth" replace />;
  if (!isCsAdmin) return <Navigate to="/" replace />;
  return children;
};

export default RequireCsAdmin;
